export default __webpack_public_path__ + "static/media/img-gr-gift-card.2b1f0f09.png";